<template>
  <div id="standardizationFiles">
    <div
      class="flex flex1 justify-between item-center button-title__box"
    >
      <div class="flex justify-start">
        <GreenButton
          class="button__default"
          text="填报"
          @click="createChange"
        ></GreenButton>
      </div>
    </div>
    <el-table
      :data="dataList"
      :header-cell-style="{background: 'rgba(0,0,0,0.02)',borderTop:'1px solid rgba(0,0,0,0.1)'}"
      :loading="loading"
      class="table-box"
      height="calc(100% - 165px)"
    >
      <el-table-column
        label="附件"
      >
        <template #default="scope">
          <div
            class="file-download pointer"
            @click="downloadFileChange(scope.row)"
          >{{ scope.row['Name'] }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="上传人"
        prop="CreationUser"
        width="200"
      ></el-table-column>
      <el-table-column
        label="上传时间"
        prop="CreationDate"
        width="160"
      >
        <template #default="scope">
          <span>{{ scope.row['CreationDate'] | timeDateFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="120"
      >
        <template #default="scope">
          <el-link
            type="primary"
            @click="deleteInfo(scope.row)"
          >
            删除
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <div
      class="table-box__pagination flex flex1 justify-end items-center"
    >
      <el-pagination
        :current-page.sync="pageIndex"
        :page-size.sync="pageSize"
        :total="allTotal"
        layout="total, prev, pager, next"
        @current-change="onPageIndexChange"
      ></el-pagination>
    </div>
    <CreateSubcontractingManagement
      :visible="createDialogVisible"
      type="standardization"
      @closeDialog="onImportDialogClose"
      @refresh="onRefreshDialogClose"
    ></CreateSubcontractingManagement>
    <el-image-viewer
      v-if="isShowImage"
      :on-close="
          () => {
            isShowImage = false
          }
        "
      :url-list="srcList"
    ></el-image-viewer>
  </div>
</template>
<script>
import GreenButton from '@/components/buttons/GreenButton'
import CreateSubcontractingManagement from '@/components/dialog/CreateSubcontractingManagement'

let _this = void 0

export default {
  name: 'standardizationFiles',
  mixins: [],
  components: { GreenButton, CreateSubcontractingManagement },
  props: {},
  data() {
    return {
      pageIndex: 1,
      pageSize: 11,
      allTotal: 0,
      loading: false,
      dataList: [],
      createDialogVisible: false,
      isShowImage: false,
      srcList: []
    }
  },
  computed: {
    //...mapState('', {}),
  },
  watch: {},
  filters: {
    timeDateFilter(date) {
      return typeof date === 'string' ? date.split('T')[0] : ''
    },
  },
  directives: {},
  created() {
    _this = this
  },
  async mounted() {
    await this.getDataInfo()
  },
  destroy() {
  },
  methods: {
    //...mapMutations('', []),
    /**
     * 获取 施工现场标准化相关文件 数据
     * */
    async getDataInfo() {
      this.loading = true
      const { success, data } = await this.$http({
        url: this.$api.getPageQueryConstructionStandardFile,
        params: {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        }
      })
      if (success) {
        const { rows, total } = data
        if (data.hasOwnProperty('rows')) {
          this.dataList = [...rows]
          if (data.hasOwnProperty('total')) {
            this.allTotal = total
          }
        }
      }
      this.loading = false
    },
    /**
     * 切换分页
     * */
    onPageIndexChange(pageIndex) {
      this.pageIndex = pageIndex
      this.getDataInfo()
    },
    /**
     * 填报 选择
     * */
    createChange() {
      this.createDialogVisible = true
    },
    /**
     * 填报 关闭dialog回调
     * */
    onImportDialogClose(type) {
      this.createDialogVisible = false
    },
    /**
     * 填报 刷新dialog回调
     * */
    onRefreshDialogClose(type) {
      this.createDialogVisible = false
      this.pageIndex = 1
      this.getDataInfo()
    },
    /**
     * 删除信息
     * */
    deleteInfo(item) {
      const { ID } = item
      this.$confirm('是否确认删除', `删除施工现场标准化相关文件`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '删除中...'
            setTimeout(async () => {
              await this.deleteChange(ID)
              done()
              setTimeout(() => {
                instance.confirmButtonLoading = false
              }, 300)
            }, 300)
          }
          else {
            done()
          }
        }
      })
    },
    /**
     * 确认删除
     * */
    async deleteChange(ID) {
      const { success } = await this.$http({
        url: this.$api.goDeleteDocumentVersionsByVersionIDs,
        params: {
          ids: ID
        }
      })
      if (success) {
        this.$message.success('删除成功')
        this.pageIndex = 1
        await this.getDataInfo()
      }
    },
    /**
     * 下载文件
     * */
    downloadFileChange(item) {
      const { RemotePath, Name, Suffix } = item
      const imageCategory = ['.png', '.jpg', '.jpeg', '.svg', '.gif']
      if (RemotePath !== '') {
        this.srcList = []
        if (imageCategory.includes(Suffix)) {
          this.isShowImage = true
          const newUrl = `${WEB_CONFIG.BASE_URL}${RemotePath}`
          this.srcList.push(newUrl)
        }
        else {
          this.$downloadFileChange(RemotePath)
        }
      }
      else {
        this.$message.error('下载失败')
      }
    }
  }
}
</script>
<style
  lang="scss"
  scoped
>
#standardizationFiles {
  height: 100%;
}

::v-deep .el-link.el-link--primary {
  color: #005BAC;
}
</style>
<style lang="scss"></style>
